import Swal from "sweetalert2";
import axios from "../../axios";
import { setAlert } from "./alert";
import { ADD_BANK, DELETE_BANK, DELETE_BANK_IMAGE, GET_BANKS, UPDATE_BANK, UPDATE_BANK_STATUS } from "../types";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const addBank = (formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
  };
    const res = await axios.post("bank/add", formData, config);
    if (res.data.code === 1) {
      dispatch({ type: ADD_BANK, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
      if (res.data.code === 0) {
        console.log("here :", res.data.message);  
        Swal.fire({
          title: 'warning!',
          text: res.data.message,
          icon: 'warning',
      });
    }
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // Use the global error message function
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
        title: 'Error!',
        text: errorMessage,
        icon: 'error',
    });
  }
};
export const getBank = () => async (dispatch) => {
  try {
    const res = await axios.get("bank/all");
    // console.log("state :", res.data);
    if (res.data.code === 1) {
      dispatch({ type: GET_BANKS, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};


export const updateBank = (formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    
    const res = await axios.post("bank/update", formData, config);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_BANK, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
    });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const updateBankStatus = (formData) => async (dispatch) => {
  try {

    const updatedFormData = {
      id: formData.id,
      ...(formData.status !== undefined && { status: formData.status }),
    };
    
    const res = await axios.post("bank/update/status", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_BANK_STATUS, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
    });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const deleteBank = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`bank/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_BANK, payload: { id } });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const deleteBankImage = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Bank ID is required", "warning"));
      return false;
    }
    const res = await axios.post(`bank/delete/image/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_BANK_IMAGE, payload: { id } });
      Swal.fire({
        title: "Deleted!",
        text: res.data.message || "Image deleted successfully",
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
      return true;
    } else {
      Swal.fire({
        title: "Warning!",
        text: res.data.message || "Could not delete image",
        icon: "warning",
      });
      dispatch(setAlert(res.data.message, "warning"));
      return false;
    }
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message;
    dispatch(setAlert(errorMessage, "danger"));
    Swal.fire({ title: "Error!", text: errorMessage, icon: "error" });
    return false;
  }
};
